import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Alert } from "react-bootstrap";
import { useCompanies } from "../../../../context/CompanyContext";
import { validateBase } from "../../../../validation/baseValidation";
import classes from "./EditBaseModal.module.scss";

const EditBaseModal = ({
  t,
  show,
  onClose,
  onSave,
  base,
  tableType = "bases",
}) => {
  const { companies } = useCompanies();
  const [formData, setFormData] = useState({
    baseid: "",
    hw: "",
    sw: "",
    pin: "",
    apn1: "",
    apn2: "",
    gprsusername1: "",
    gprsusername2: "",
    gprspassword1: "",
    gprspassword2: "",
    gprsuserparam11: "",
    gprsuserparam21: "",
    gprsuserparam12: "",
    gprsuserparam22: "",
    serveraddress1: "",
    serveraddress2: "",
    serverport1: "",
    serverport2: "",
    gprscycletime: "",
    gprserrordelay: "",
    gprsretrycount: "",
    basefiltering: "",
    modbusenabled: false,
    modbusaddress: "",
    modbusbaudrate: "",
    modbusconfig: "",
    probesamplecount: "",
    probesampletime: "",
    gprscontcomm: "",
    loggedin: false,
    modifyconfig: false,
    logoutdate: "",
    logindate: "",
    products_id: "", // I dont think this is necessary
    archivedatacount: "",
    measvalidtime: "",
    validconfig: false,
    sim_id: "",
    companies_id: "", // I dont think this is necessary
  });
  const [validated, setValidated] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [error, setError] = useState("");

  // Initialize form data when base prop changes
  useEffect(() => {
    if (base) {
      setFormData({
        ...base,
        modbusenabled: base.modbusenabled || false, // Ensure boolean value
        loggedin: base.loggedin || false, // Ensure boolean value
        modifyconfig: base.modifyconfig || false, // Ensure boolean value
        validconfig: base.validconfig || false,
      });
      setValidated(false);
      setValidationErrors({});
      setError("");
    }
  }, [base]);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Clone formData to avoid modifying state directly
    const formDataToSubmit = { ...formData };

    // Validate the form data
    const errors = validateBase(formDataToSubmit);
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setError(t("form_validation_error"));
      setValidated(true);
      return;
    }

    // Clear validation errors when form is valid
    setValidationErrors({});
    setError("");

    // Add the original base ID for update
    formDataToSubmit.id = base._id;

    try {
      onSave(formDataToSubmit);
      setError("");
      onClose();
    } catch (err) {
      setError(t("error_updating_base"));
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      centered
      className={classes.editProductModal}
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("edit_base")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Row>
            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="baseid">
                <Form.Label>{t("baseid")}</Form.Label>
                <Form.Control
                  type="text"
                  name="baseid"
                  value={formData.baseid}
                  onChange={handleChange}
                  required
                  isInvalid={!!validationErrors.baseid}
                  className={`${
                    tableType ? `modal-${tableType}-field-baseid` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.baseid
                    ? t(validationErrors.baseid)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="hw">
                <Form.Label>{t("hardware")}</Form.Label>
                <Form.Control
                  type="text"
                  name="hw"
                  value={formData.hw}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.hw}
                  className={`${
                    tableType ? `modal-${tableType}-field-hw` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.hw
                    ? t(validationErrors.hw)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="sw">
                <Form.Label>{t("software")}</Form.Label>
                <Form.Control
                  type="text"
                  name="sw"
                  value={formData.sw}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.sw}
                  className={`${
                    tableType ? `modal-${tableType}-field-sw` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.sw
                    ? t(validationErrors.sw)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="pin">
                <Form.Label>{t("pin")}</Form.Label>
                <Form.Control
                  type="text"
                  name="pin"
                  value={formData.pin}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.pin}
                  className={`${
                    tableType ? `modal-${tableType}-field-pin` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.pin
                    ? t(validationErrors.pin)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* APN Settings */}
            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="apn1">
                <Form.Label>{t("apn1")}</Form.Label>
                <Form.Control
                  type="text"
                  name="apn1"
                  value={formData.apn1}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.apn1}
                  className={`${
                    tableType ? `modal-${tableType}-field-apn1` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.apn1
                    ? t(validationErrors.apn1)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="apn2">
                <Form.Label>{t("apn2")}</Form.Label>
                <Form.Control
                  type="text"
                  name="apn2"
                  value={formData.apn2}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.apn2}
                  className={`${
                    tableType ? `modal-${tableType}-field-apn2` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.apn2
                    ? t(validationErrors.apn2)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* GPRS Credentials */}
            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="gprsusername1">
                <Form.Label>{t("gprsusername1")}</Form.Label>
                <Form.Control
                  type="text"
                  name="gprsusername1"
                  value={formData.gprsusername1}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.gprsusername1}
                  className={`${
                    tableType ? `modal-${tableType}-field-gprsusername1` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.gprsusername1
                    ? t(validationErrors.gprsusername1)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="gprsusername2">
                <Form.Label>{t("gprsusername2")}</Form.Label>
                <Form.Control
                  type="text"
                  name="gprsusername2"
                  value={formData.gprsusername2}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.gprsusername2}
                  className={`${
                    tableType ? `modal-${tableType}-field-gprsusername2` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.gprsusername2
                    ? t(validationErrors.gprsusername2)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="gprspassword1">
                <Form.Label>{t("gprspassword1")}</Form.Label>
                <Form.Control
                  type="password"
                  name="gprspassword1"
                  value={formData.gprspassword1}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.gprspassword1}
                  className={`${
                    tableType ? `modal-${tableType}-field-gprspassword1` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.gprspassword1
                    ? t(validationErrors.gprspassword1)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="gprspassword2">
                <Form.Label>{t("gprspassword2")}</Form.Label>
                <Form.Control
                  type="password"
                  name="gprspassword2"
                  value={formData.gprspassword2}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.gprspassword2}
                  className={`${
                    tableType ? `modal-${tableType}-field-gprspassword2` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.gprspassword2
                    ? t(validationErrors.gprspassword2)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* GPRS User Parameters */}
            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="gprsuserparam11">
                <Form.Label>{t("gprsuserparam11")}</Form.Label>
                <Form.Control
                  type="text"
                  name="gprsuserparam11"
                  value={formData.gprsuserparam11}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.gprsuserparam11}
                  className={`${
                    tableType ? `modal-${tableType}-field-gprsuserparam11` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.gprsuserparam11
                    ? t(validationErrors.gprsuserparam11)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="gprsuserparam21">
                <Form.Label>{t("gprsuserparam21")}</Form.Label>
                <Form.Control
                  type="text"
                  name="gprsuserparam21"
                  value={formData.gprsuserparam21}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.gprsuserparam21}
                  className={`${
                    tableType ? `modal-${tableType}-field-gprsuserparam21` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.gprsuserparam21
                    ? t(validationErrors.gprsuserparam21)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="gprsuserparam12">
                <Form.Label>{t("gprsuserparam12")}</Form.Label>
                <Form.Control
                  type="text"
                  name="gprsuserparam12"
                  value={formData.gprsuserparam12}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.gprsuserparam12}
                  className={`${
                    tableType ? `modal-${tableType}-field-gprsuserparam12` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.gprsuserparam12
                    ? t(validationErrors.gprsuserparam12)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="gprsuserparam22">
                <Form.Label>{t("gprsuserparam22")}</Form.Label>
                <Form.Control
                  type="text"
                  name="gprsuserparam22"
                  value={formData.gprsuserparam22}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.gprsuserparam22}
                  className={`${
                    tableType ? `modal-${tableType}-field-gprsuserparam22` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.gprsuserparam22
                    ? t(validationErrors.gprsuserparam22)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Server Configuration */}
            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="serveraddress1">
                <Form.Label>{t("serveraddress1")}</Form.Label>
                <Form.Control
                  type="text"
                  name="serveraddress1"
                  value={formData.serveraddress1}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.serveraddress1}
                  className={`${
                    tableType ? `modal-${tableType}-field-serveraddress1` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.serveraddress1
                    ? t(validationErrors.serveraddress1)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="serveraddress2">
                <Form.Label>{t("serveraddress2")}</Form.Label>
                <Form.Control
                  type="text"
                  name="serveraddress2"
                  value={formData.serveraddress2}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.serveraddress2}
                  className={`${
                    tableType ? `modal-${tableType}-field-serveraddress2` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.serveraddress2
                    ? t(validationErrors.serveraddress2)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="serverport1">
                <Form.Label>{t("serverport1")}</Form.Label>
                <Form.Control
                  type="text"
                  name="serverport1"
                  value={formData.serverport1}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.serverport1}
                  className={`${
                    tableType ? `modal-${tableType}-field-serverport1` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.serverport1
                    ? t(validationErrors.serverport1)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="serverport2">
                <Form.Label>{t("serverport2")}</Form.Label>
                <Form.Control
                  type="text"
                  name="serverport2"
                  value={formData.serverport2}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.serverport2}
                  className={`${
                    tableType ? `modal-${tableType}-field-serverport2` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.serverport2
                    ? t(validationErrors.serverport2)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* GPRS Settings */}
            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="gprscycletime">
                <Form.Label>{t("gprscycletime")}</Form.Label>
                <Form.Control
                  type="text"
                  name="gprscycletime"
                  value={formData.gprscycletime}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.gprscycletime}
                  className={`${
                    tableType ? `modal-${tableType}-field-gprscycletime` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.gprscycletime
                    ? t(validationErrors.gprscycletime)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="gprserrordelay">
                <Form.Label>{t("gprserrordelay")}</Form.Label>
                <Form.Control
                  type="text"
                  name="gprserrordelay"
                  value={formData.gprserrordelay}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.gprserrordelay}
                  className={`${
                    tableType ? `modal-${tableType}-field-gprserrordelay` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.gprserrordelay
                    ? t(validationErrors.gprserrordelay)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="gprsretrycount">
                <Form.Label>{t("gprsretrycount")}</Form.Label>
                <Form.Control
                  type="text"
                  name="gprsretrycount"
                  value={formData.gprsretrycount}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.gprsretrycount}
                  className={`${
                    tableType ? `modal-${tableType}-field-gprsretrycount` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.gprsretrycount
                    ? t(validationErrors.gprsretrycount)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="basefiltering">
                <Form.Label>{t("basefiltering")}</Form.Label>
                <Form.Control
                  type="text"
                  name="basefiltering"
                  value={formData.basefiltering}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.basefiltering}
                  className={`${
                    tableType ? `modal-${tableType}-field-basefiltering` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.basefiltering
                    ? t(validationErrors.basefiltering)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Modbus Settings */}
            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="modbusenabled">
                <Form.Check
                  type="checkbox"
                  label={t("modbusenabled")}
                  name="modbusenabled"
                  checked={formData.modbusenabled}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      modbusenabled: e.target.checked,
                    })
                  }
                  isInvalid={!!validationErrors.modbusenabled}
                  className={`${
                    tableType ? `modal-${tableType}-field-modbusenabled` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.modbusenabled
                    ? t(validationErrors.modbusenabled)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="modbusaddress">
                <Form.Label>{t("modbusaddress")}</Form.Label>
                <Form.Control
                  type="text"
                  name="modbusaddress"
                  value={formData.modbusaddress}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.modbusaddress}
                  className={`${
                    tableType ? `modal-${tableType}-field-modbusaddress` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.modbusaddress
                    ? t(validationErrors.modbusaddress)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="modbusbaudrate">
                <Form.Label>{t("modbusbaudrate")}</Form.Label>
                <Form.Control
                  type="text"
                  name="modbusbaudrate"
                  value={formData.modbusbaudrate}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.modbusbaudrate}
                  className={`${
                    tableType ? `modal-${tableType}-field-modbusbaudrate` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.modbusbaudrate
                    ? t(validationErrors.modbusbaudrate)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="modbusconfig">
                <Form.Label>{t("modbusconfig")}</Form.Label>
                <Form.Control
                  type="text"
                  name="modbusconfig"
                  value={formData.modbusconfig}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.modbusconfig}
                  className={`${
                    tableType ? `modal-${tableType}-field-modbusconfig` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.modbusconfig
                    ? t(validationErrors.modbusconfig)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Probe Settings */}
            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="probesamplecount">
                <Form.Label>{t("probesamplecount")}</Form.Label>
                <Form.Control
                  type="text"
                  name="probesamplecount"
                  value={formData.probesamplecount}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.probesamplecount}
                  className={`${
                    tableType ? `modal-${tableType}-field-probesamplecount` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.probesamplecount
                    ? t(validationErrors.probesamplecount)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="probesampletime">
                <Form.Label>{t("probesampletime")}</Form.Label>
                <Form.Control
                  type="text"
                  name="probesampletime"
                  value={formData.probesampletime}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.probesampletime}
                  className={`${
                    tableType ? `modal-${tableType}-field-probesampletime` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.probesampletime
                    ? t(validationErrors.probesampletime)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="gprscontcomm">
                <Form.Label>{t("gprscontcomm")}</Form.Label>
                <Form.Control
                  type="text"
                  name="gprscontcomm"
                  value={formData.gprscontcomm}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.gprscontcomm}
                  className={`${
                    tableType ? `modal-${tableType}-field-gprscontcomm` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.gprscontcomm
                    ? t(validationErrors.gprscontcomm)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Status Fields */}
            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="loggedin">
                <Form.Check
                  type="checkbox"
                  label={t("loggedin")}
                  name="loggedin"
                  checked={formData.loggedin}
                  onChange={(e) =>
                    setFormData({ ...formData, loggedin: e.target.checked })
                  }
                  isInvalid={!!validationErrors.loggedin}
                  className={`${
                    tableType ? `modal-${tableType}-field-loggedin` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.loggedin
                    ? t(validationErrors.loggedin)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="modifyconfig">
                <Form.Check
                  type="checkbox"
                  label={t("modifyconfig")}
                  name="modifyconfig"
                  checked={formData.modifyconfig}
                  onChange={(e) =>
                    setFormData({ ...formData, modifyconfig: e.target.checked })
                  }
                  isInvalid={!!validationErrors.modifyconfig}
                  className={`${
                    tableType ? `modal-${tableType}-field-modifyconfig` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.modifyconfig
                    ? t(validationErrors.modifyconfig)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="validconfig">
                <Form.Check
                  type="checkbox"
                  label={t("validconfig")}
                  name="validconfig"
                  checked={formData.validconfig}
                  onChange={(e) =>
                    setFormData({ ...formData, validconfig: e.target.checked })
                  }
                  isInvalid={!!validationErrors.validconfig}
                  className={`${
                    tableType ? `modal-${tableType}-field-validconfig` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.validconfig
                    ? t(validationErrors.validconfig)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Date Fields */}
            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="logoutdate">
                <Form.Label>{t("logoutdate")}</Form.Label>
                <Form.Control
                  type="datetime-local"
                  name="logoutdate"
                  value={formData.logoutdate}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.logoutdate}
                  className={`${
                    tableType ? `modal-${tableType}-field-logoutdate` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.logoutdate
                    ? t(validationErrors.logoutdate)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="logindate">
                <Form.Label>{t("logindate")}</Form.Label>
                <Form.Control
                  type="datetime-local"
                  name="logindate"
                  value={formData.logindate}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.logindate}
                  className={`${
                    tableType ? `modal-${tableType}-field-logindate` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.logindate
                    ? t(validationErrors.logindate)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Other Fields */}
            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="archivedatacount">
                <Form.Label>{t("archivedDataCount")}</Form.Label>
                <Form.Control
                  type="text"
                  name="archivedatacount"
                  value={formData.archivedatacount}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.archivedatacount}
                  className={`${
                    tableType ? `modal-${tableType}-field-archivedatacount` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.archivedatacount
                    ? t(validationErrors.archivedatacount)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="measvalidtime">
                <Form.Label>{t("measvalidtime")}</Form.Label>
                <Form.Control
                  type="text"
                  name="measvalidtime"
                  value={formData.measvalidtime}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.measvalidtime}
                  className={`${
                    tableType ? `modal-${tableType}-field-measvalidtime` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.measvalidtime
                    ? t(validationErrors.measvalidtime)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} className={classes.formGroup}>
              <Form.Group controlId="sim_id">
                <Form.Label>{t("sim")}</Form.Label>
                <Form.Control
                  type="text"
                  name="sim_id"
                  value={formData.sim_id}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.sim_id}
                  className={`${
                    tableType ? `modal-${tableType}-field-sim_id` : ""
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.sim_id
                    ? t(validationErrors.sim_id)
                    : t("required_field")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditBaseModal;
